// eslint-disable-next-line import/prefer-default-export
export enum MapType {
  "text field" = 0,
  "list field" = 1,
}
